import React, { useEffect } from "react";
import styles from "./scss/readreceiptlist.module.scss";
import moment from "moment";
import { getcontactDetail } from "../../../base/utils";
import { Tooltip } from "antd";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import { userStatusColor } from "../../../base/callService/common";
import { chatSideWindow } from "../../../base/eventService/eventApiService";
import _ from "lodash";

type receiptProps = {
  receiptLists: any
}
export default function ReadReceiptList({ receiptLists }: receiptProps) {
  let deliveryCount = Object.keys(receiptLists?.deliveryreport) && Object.keys(receiptLists?.deliveryreport)?.length;
  let readCount = Object.keys(receiptLists?.readreport) && Object.keys(receiptLists?.readreport)?.length;

  let len = Math.ceil((deliveryCount / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  let sent_info = receiptLists?.to !== ""?receiptLists?.to?.split(','):"";
 const closeWindow = ()=>{
  chatSideWindow(true,"",{});
 }
 useEffect(() => {
   
}, [deliveryCount,readCount]);


  return (
    <>
        <div className={styles.receiptListsCon}>
            <div className={styles.toplayers}>
              <h3>Read Receipt Info</h3>
              <Tooltip mouseEnterDelay={0.5} placement="topRight" title="Close" overlayClassName="tooltipCenter">
                <span className="icon_close" onClick={closeWindow}></span>
                </Tooltip>
            </div>
            <div className={styles.readreceiptright}>
              <div className={styles.innerbdyconsec}>
                  <div className={styles.defaultSec}>
                      <div className={styles.headercount}>
                          <h3>Read <span>({readCount})</span></h3>
                      </div>
                    {Object.keys(receiptLists.readreport) && Object.keys(receiptLists.readreport).length>0 && 
                      Object.keys(receiptLists.readreport).map((value:any,index:any)=>{
                        var sip = value.substring(1);
                        let contactsDetail = getcontactDetail(sip);
                        let timestamp = receiptLists?.readreport[value];
                        return(
                          <>
                          <div className={styles.readlistuser}>
                          <div className={styles.lftusersec}>
                          <URAvatarGroup className={`lefts size16 noOutline colorBG${random_color[index]}`}
                            profileInfo={
                              (!_.isUndefined(contactsDetail)&&contactsDetail?.ImageURL !== null && contactsDetail?.ImageURL !== "") ?
                                (<>
                                  <img src={contactsDetail?.ImageURL} className="positionrel" alt="" />
                                  <URStatusDot className={`stsDotsm botmnone ${userStatusColor(contactsDetail?.user_status,'small')}`}/></>) :
                                (<>
                                  <span>{contactsDetail?.caller_id?.charAt(0).toUpperCase()} </span>
                                  <URStatusDot className={`stsDotsm botmnone ${userStatusColor(contactsDetail?.user_status,'small')}`}/>
                                </>)
                            } />
                            <h3>{contactsDetail?.caller_id}</h3>
                            </div>
                          <div className={styles.rightusersec}>
                                <span>{moment(timestamp).format('hh:mm A')}</span>
                            </div>
                            </div>
                          </>
                        )
                      })
                    }
                </div>
              </div>
              <div className={styles.innerbdyconsec}>
                <div className={styles.defaultSec}>
                    <div className={styles.headercount}>
                        <h3>Delivered <span>({deliveryCount})</span></h3>
                    </div>
                  {Object.keys(receiptLists?.deliveryreport) && Object.keys(receiptLists?.deliveryreport).length>0 && 
                    Object.keys(receiptLists?.deliveryreport).map((value:any,index:any)=>{
                      var sip = value.substring(1);
                      let contactsDetail = getcontactDetail(sip);
                      let timestamp = receiptLists?.deliveryreport[value];
                      return(
                        <>
                        <div className={styles.readlistuser}>
                        <div className={styles.lftusersec}>
                        <URAvatarGroup className={`lefts size16 noOutline colorBG${random_color[index]}`}
                          profileInfo={
                            (contactsDetail?.ImageURL !== null && contactsDetail?.ImageURL !== "") ?
                              (<>
                                <img src={contactsDetail?.ImageURL} className="positionrel" alt="" />
                                <URStatusDot className={`stsDotsm botmnone ${userStatusColor(contactsDetail?.user_status,'small')}`}/></>) :
                              (<>
                                <span>{contactsDetail?.caller_id?.charAt(0).toUpperCase()} </span>
                                <URStatusDot className={`stsDotsm botmnone ${userStatusColor(contactsDetail?.user_status,'small')}`}/>
                              </>)
                          } />
                          <h3>{contactsDetail?.caller_id}</h3>
                          </div>
                          <div className={styles.rightusersec}>
                              <span>{moment(timestamp).format('hh:mm A')}</span>
                          </div>
                        </div>
                      </>
                      )
                    })
                }    
                </div>
              </div>
              <div className={styles.innerbdyconsec}>                   
                <div className={styles.defaultSec}>
                      <div className={styles.headercount}>
                          <h3>Sent <span>({sent_info?.length})</span></h3>
                      </div>
                      {Array.isArray(sent_info) && sent_info?.length>0 && 
                      sent_info.map((value:any,index:any)=>{
                        let contactsDetail = getcontactDetail(value);
                        return(
                          <>
                          <div className={styles.readlistuser}>
                          <div className={styles.lftusersec}>
                          <URAvatarGroup className={`lefts size16 noOutline colorBG${random_color[index]}`}
                            profileInfo={
                              (contactsDetail?.ImageURL !== null && contactsDetail?.ImageURL !== "") ?
                                (<>
                                  <img src={contactsDetail?.ImageURL} className="positionrel" alt="" />
                                  <URStatusDot className={`stsDotsm botmnone ${userStatusColor(contactsDetail?.user_status,'small')}`}/></>) :
                                (<>
                                  <span>{contactsDetail?.caller_id?.charAt(0).toUpperCase()} </span>
                                  <URStatusDot className={`stsDotsm botmnone ${userStatusColor(contactsDetail?.user_status,'small')}`}/>
                                </>)
                            } />
                            <h3>{contactsDetail?.caller_id}</h3>
                            </div>
                            <div className={styles.rightusersec}>
                                <span>{moment(receiptLists?.timestamp).format('hh:mm A')}</span>
                            </div>
                        </div>

                      </>
                        )
                      })
                  }    
                    
                </div>
              </div>
            </div>
        </div>
    </>

  );
};

